<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" @change="agentChange" v-model="query.agentId" filterable clearable
					placeholder="请选择代理商" class="handle-select mr10" style="width: 200px;">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" style="width: 200px" v-model="query.companyId" filterable clearable
					placeholder="企业" class="handle-select mr10">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-input size="small" v-model="query.phone" clearable maxlength="12" placeholder="请输入号码"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-select size="small" v-model="query.operateMsg" filterable clearable placeholder="请选择停机类型"
					class="handle-select mr10">
					<el-option v-for="item in operateMsgList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" style="width: 100px" v-model="query.status" filterable clearable
					placeholder="状态" class="handle-select mr10">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getData">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="getstopVisible">批量停机</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" v-loading="loading"
				:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="agent" label="代理商" align="center"></el-table-column>
				<el-table-column prop="company" label="企业" align="center"></el-table-column>
				<el-table-column prop="phone" label="号码" align="center"></el-table-column>
				<el-table-column prop="operateMsg" label="停机类型" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" align="center"></el-table-column>
				<el-table-column prop="status" label="状态" align="center">
					<template #default="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
							v-if="scope.row.status=='失败'">
							<span style="color: #f56c6c;">失败</span>
						</el-tooltip>
						<span v-else>{{scope.row.status}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createdAt" label="时间" width="180" align="center"></el-table-column>
				<el-table-column prop="userPhone" label="操作员" align="center"></el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
			<el-dialog title="批量停机" v-model="stopVisible" width="520px" @close="closeDialog">
				<el-form label-width="120px" :model="stopForm" ref="stopForm">
					<el-form-item label="选择模式" prop="type">
						<el-radio-group v-model="stopForm.type">
							<el-radio label="2">手动输入</el-radio>
							<el-radio label="1">批量停开机模板</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="手机号码" prop="phones" v-if="stopForm.type == '2'">
						<el-input size="small" :rows="5" type="textarea" v-model="stopForm.phones" auto-complete="off"
							placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
					</el-form-item>
					<el-form-item label="上传文件" prop="" v-else>
						<el-upload ref="upload" action="/api/gome/stopPhone" :headers="token" :limit="1"
							:on-success="uploadSuccess" :auto-upload="false" :data="stopForm">
							<el-button size="small" type="primary" :class="[theme]"
								style="margin-top: 40px;">选择文件</el-button>
							<div class="el-upload__tip">只能导入txt文件</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="停机类型" prop="operateMsg">

						<el-radio-group v-model="stopForm.operateMsg">
							<el-radio v-for="item in operateMsgList" :key="item" :label="item.value"
								style="margin: 4px;font-size: 16px;" :value="item.value">{{item.label}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input size="small" :rows="5" type="textarea" v-model="stopForm.remark" auto-complete="off"
							placeholder="请输入停机备注"></el-input>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="closeDialog">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]" v-if="stopForm.type == '2'"
							@click="batchStop">确定</el-button>
						<el-button size="small" type="primary" :class="[theme]" v-else
							@click="submitUpload">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>

		</div>
	</div>
</template>

<script>
	import {
		stopRecord,
		stopPhone
	} from '../api/gm.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		fetchAgent
	} from '../api/agentIndex';
	export default {
		name: 'gmRecharge',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				agents: [],
				companys: [],
				query: {
					agentId: '',
					companyId: '',
					phone: '',
					operateMsg: '',
					status: null,
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				tableData: [],
				pageTotal: 0,
				multipleSelection: [],
				operateMsgList: [{
						value: 'Q01',
						label: 'Q01-代理商管控关停，实名补登记复机'
					},
					{
						value: 'Q02',
						label: 'Q02-代理商管控关停，二次实人认证复机'
					},
					{
						value: 'Q03',
						label: 'Q03-代理商管控关停，强停不予复机'
					},
					{
						value: 'Q04',
						label: 'Q03-外部平台脱离APP管控停机'
					},
				],
				statusList: [{
						value: null,
						label: '全部'
					},
					{
						value: '0',
						label: '成功'
					},
					{
						value: '-1',
						label: '失败'
					},
				],
				stopVisible: false,
				stopForm: {
					userId: localStorage.getItem('user'),
					type: '2',
					phones: '',
					operateMsg: 'Q01',
					remark: '',
				},
				uploadData: {
					userId: localStorage.getItem('user'),
				},
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
			};
		},

		created() {
			this.init();
			this.getData(); //列表
			this.updatePaginationStyle();
		},

		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				let data1 = {
					currentUserId: localStorage.getItem('user')
				};
				fetchDefaultCompanies(data1).then(res => {
					this.companys = res.data;
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			getData() {
				let data = {
					phone: this.query.phone,
					operateMsg: this.query.operateMsg,
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					status: this.query.status,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
				};
				this.loading = true;
				stopRecord(data).then(res => {
					this.loading = false;
					this.tableData = res.data.list;
					this.pageTotal = res.data.total;
				});

			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.$refs.upload.clearFiles();
					this.stopVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					setTimeout(() => {
						this.getData();
					}, 2000);
				} else {
					this.$message.error(success.message);
				}
			},
			getstopVisible() {
				this.stopVisible = true;
				this.stopForm.type = '2';
				this.stopForm.phones = '';
				this.stopForm.operateMsg = 'Q01';
				this.stopForm.remark = '';
			},
			closeDialog() {
				this.stopVisible = false;
			},
			//批量停机 =》手动输入
			batchStop() {
				stopPhone(this.stopForm).then(res => {
					if (res?.code === 200) {
						setTimeout(() => {
							this.stopVisible = false;
							this.getData();
						}, 2000);
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	/* a:hover {
	background: #66b1ff;
} */
	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.el-radio__input {
		display: none;
	}

	.el-radio.is-bordered {
		padding: 8px 14px 0 5px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 30px;
	}



	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;

		display: inline-block;
	}
</style>